import { get, writable } from 'svelte/store'
export const navHeight = writable(80 + 52 + 40)

export const navbarHeight = 130
export const subNavbarHeight = 40
export const footerHeight = 40

export const appSelected = writable('') // 'Phy' || 'APP' || 'Other'
export const tabSelected = writable('')
export const subTabSelected = writable(null)
export const sidebarOpen = writable(false)

export const isMessageShown = writable(true)

function createStore() {
  const { subscribe, set, update } = writable({
    data: [],
    loading: false,
  })

  const store = {
    subscribe,
    set,
    update,
    get: () => get({ subscribe }).data,
  }

  return store
}
/**
 * Represent the tiles that are shown in the dashboard
 * @type {import('svelte/store').Writable<Array<{code: string, title: string, description: string, tooltip: string, type: string, isEnabled: boolean}>>}
 */
export const tilesInfo = writable(null)

export const myFeatures = createStore()

if (process.env.NODE_ENV !== 'production') {
  // @ts-ignore
  window.tilesInfo = tilesInfo // set the user from the store for testing porpouses
}

export const sectionSelected = get(appSelected) || 'Phy'
